import React from "react";
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { selectMenuProps } from "../../../util";

const SelectWithUserRoles = ({ selectedUserRoles, setSelectedUserRoles, displayEmpty }) => {
  const userRoles = [
    { value: "AGENT", label: "app.agent" },
    { value: "CUSTOMER", label: "app.customer" },
  ];

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedUserRoles(Array.isArray(value) ? value : []);
  };

  const valueToLabelMap = userRoles.reduce((map, item) => {
    map[item.value] = item.label;
    return map;
  }, {});

  const getSelectedLabel = (selected) => {
    if (selected.length === 0 && displayEmpty) {
      return (
        <>
          <FormattedMessage id="app.all" />
        </>
      );
    }
    return selected
      .map((val) => (
        <FormattedMessage
          key={val}
          id={valueToLabelMap[val]}
        />
      ))
      .reduce((prev, curr) => [prev, ", ", curr]);
  };

  return (
    <FormControl
      fullWidth
      variant="outlined"
      size="small"
    >
      <InputLabel
        id="label-roles"
        shrink={displayEmpty}
      >
        <FormattedMessage id="app.role" />
      </InputLabel>
      <Select
        labelId="label-roles"
        multiple
        displayEmpty={displayEmpty}
        MenuProps={selectMenuProps}
        value={selectedUserRoles}
        onChange={handleChange}
        renderValue={getSelectedLabel}
        notched={displayEmpty}
        label={<FormattedMessage id="app.role" />}
      >
        {userRoles.map(({ value, label }) => (
          <MenuItem
            key={value}
            value={value}
          >
            <Checkbox
              checked={selectedUserRoles.indexOf(value) > -1}
              color="primary"
            />
            <ListItemText primary={<FormattedMessage id={label} />} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default React.memo(SelectWithUserRoles);
